/**
 * Passthrough-auth landing page — reached via Crashpad's SSO launch link.
 * Crashpad has already refreshed an Atoll token pair scoped to this app's
 * own audience; store it and run the same bootstrap flow App.tsx uses on
 * a normal reload (refreshSession -> loginSuccess), then land on "/".
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { refreshSession } from '../shared/atoll/atollAuth'
import { setJwtToken, setRefreshToken } from '../shared/services/shared'
import { loginSuccess, setLoginOpen } from '../shared/atoll/redux/authSlice'
import { useAppDispatch } from '../shared/services/redux/hooks'

export default function SsoLaunch() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const accessToken = params.get('access_token')
    const refreshToken = params.get('refresh_token')

    if (!accessToken || !refreshToken) {
      navigate('/', { replace: true })
      return
    }

    setJwtToken(accessToken)
    setRefreshToken(refreshToken)

    refreshSession(dispatch).then((result) => {
      if (result.success && result.data?.user) {
        dispatch(loginSuccess(result.data.user))
        dispatch(setLoginOpen(false))
      } else {
        dispatch(setLoginOpen(true))
      }
      navigate('/', { replace: true })
    })
  }, [])

  return null
}
